export enum HeadsUpOperationKind {
  Idle = "idle",
  Hydrate = "hydrate",
  Generate = "generate",
  Refresh = "refresh",
  Regenerate = "regenerate",
}

export const isContextOperation = (
  operation: HeadsUpOperationKind | undefined
): operation is Exclude<HeadsUpOperationKind, HeadsUpOperationKind.Idle> => {
  return Boolean(operation && operation !== HeadsUpOperationKind.Idle);
};
